export function footerMobileMenu() {
    const footer = $('.footer-menu');
    const btnFooterNav = `<button></button>`;

    $(btnFooterNav).insertBefore(".footer-sub-menu");

    footer.on("click", '.menu-item-has-children > strong', function (e) {
        e.preventDefault();

        if (window.innerWidth < 768) {
            let $this = $(this);
            let parent = $this.parent();
            if (!parent.hasClass("active")) {
                parent.addClass("active").find(".footer-sub-menu").slideDown();
            } else {
                parent.removeClass("active").find(".footer-sub-menu").slideUp();
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/footerMobileMenu.js